module.exports = __webpack_public_path__ + "static/media/reports.ae4d2306.svg";